module.exports = __webpack_public_path__ + "fonts/AvenyTWEB.2384f961.ttf";